import React from 'react'
import { RegisterHeader } from '../../Components/Index'
import Footer from '../../../../Layout/Footer'

export default function DpAndPrivacy () {
  return (
    <div >{/* --- Part 2: Detailed Policy --- */}
    <RegisterHeader/>
      <section className='container py-5 mt-5'>
        <div className='bg-white p-3 rounded my-2 py-5'>
        <h4 className="fw-bold text-dark mb-4">DATA PROTECTION & PRIVACY POLICY</h4>

        {/* 1. Introduction */}
        <div className="mb-4">
          <h6 className="fw-bold text-dark">1. Introduction</h6>
          <p className="small">
            The Police Service Commission (PSC) is a Federal Executive Body under Section 153 (m) of the Constitution of the Federal Republic of Nigeria, 1999 (as amended). Paragraph 30, Part 1 of the Third (3rd) Schedule to the Constitution, highlights that the Commission has power to:
          </p>
          <ul className="small" style={{ listStyleType: "none" }}>
            <li>(a) Appoint persons to offices (other than the Office of the Inspector-General of Police) in the Nigeria Police Force;</li>
            <li>(b) Dismiss and exercise disciplinary control over persons holding any office referred to in sub-paragraph (a) of this paragraph.</li>
          </ul>
          <p className="small">
            The PSC is committed to safeguarding the privacy and security of personal information. This Data Protection and Privacy Policy outline our obligation to respecting and fully protecting the personal data of individuals and complies with applicable data protection laws across all the jurisdictions in which we operate.
          </p>
        </div>

        {/* 2. Definitions */}
        <div className="mb-4">
          <h6 className="fw-bold text-dark">2. Definitions</h6>
          <p className="small">
            <span className="fw-bold">Personal Information:</span> Personal Information consists of any data that relates to an individual and/or information from which an individual can be identified, directly or indirectly. It includes but is not limited to names, contact details, date of birth, photographs, and biometric data, such as facial recognition data.
          </p>
        </div>

        {/* 3. Data Collection */}
        <div className="mb-4">
          <h6 className="fw-bold text-dark">3. Data Collection</h6>

          <p className="fw-bold small mb-1">3.1 Types of Personal Information Collected</p>
          <p className="small">This Commission, in the discharge of its Constitutional Mandate, may collect, use, store, and transfer different kinds of Personal Information about applicants. This includes, but not limited to:</p>
          <ul className="small row justify-content-start" >
            <li className="col-md-6 text-start">Names</li>
            <li className="col-md-6">Contact details</li>
            <li className="col-md-6">Date of birth</li>
            <li className="col-md-6">Photographs</li>
            <li className="col-md-6">Academic Records</li>
            <li className="col-md-6">Next of Kin details</li>
            <li className="col-md-6">Local Government of Origin</li>
            <li className="col-md-6">State of Origin</li>
            <li className="col-md-6">Past Employment information</li>
            <li className="col-md-6">Biometric data (including facial recognition data)</li>
          </ul>

          <p className="fw-bold small mb-1 mt-3">3.2 Consent and Opt-In/Opt-Out</p>
          <p className="small">
            When collecting personal data, including biometric, facial recognition, fingerprints, or other unique biological identifiers, the Police Service Commission shall obtain the explicit, informed, and unambiguous consent of the data subject before any processing occurs. By voluntarily providing such data, individuals consent to its use solely for the stated and legitimate purposes as outlined in this policy. Consent shall be freely given, specific, informed, and revocable at any time. Data subjects reserve the right to withdraw their consent or opt-out of data processing at any time, without any negative consequences. To exercise this right, individuals may contact the PSC Data Protection Officer (DPO) at: <a href="mailto:dpr@psc.gov.ng">dpr@psc.gov.ng</a>
          </p>

          <p className="fw-bold small mb-1 mt-3">3.3 How Personal Information is Collected</p>
          <p className="small">The PSC typically collects information through various means, including but not limited to:</p>
          <ul className="small" style={{ listStyleType: "bullet" }}>
            <li>Candidates’ applications online</li>
            <li>Information obtained from third parties, such as the National Identity Management Commission (NIMC), the Nigeria Police Force, past employers, regulatory bodies, and members of the public.</li>
          </ul>
        </div>

        {/* 4. Purpose */}
        <div className="mb-4">
          <h6 className="fw-bold text-dark">4. Purpose of Data Collection</h6>
          <p className="small">The PSC use the Personal Information, including biometric data, for the following purposes:</p>
          <ul className="small" style={{ listStyleType: "bullet" }}>
            <li>Screening of candidates to determine suitability for appointment;</li>
            <li>Shortlisting of candidates for Physical and Credential examination;</li>
            <li>Shortlisting of candidates for Aptitude Tests;</li>
            <li>Final Selection of successful candidates in recruitment exercises;</li>
            <li>Fulfilling promotion, disciplinary and human resource management functions;</li>
          </ul>
        </div>

        {/* 5. Sharing */}
        <div className="mb-4">
          <h6 className="fw-bold text-dark">5. Sharing of Personal Information</h6>
          <p className="small">The PSC may share Personal Information, including biometric data, with Third-party service providers, including but not limited to IT service providers and the Nigeria Police Force for processing, human resource management and mandate fulfillment interests.</p>
          <p className="small fw-bold">Consequently, the PSC will never sell or disclose any Personal Information to third parties.</p>
        </div>

        {/* 6, 7, 8, 9, 10, 11 grouped for brevity but kept distinct */}
        <div className="mb-4">
          <h6 className="fw-bold text-dark">6. Data Security</h6>
          <p className="small">PSC implements appropriate physical and technical measures to safeguard the Personal Information. Access is restricted to authorized personnel subject to confidentiality. No system is entirely secure, hence the PSC cannot guarantee the security of Personal Information.</p>

          <h6 className="fw-bold text-dark mt-3">7. Data Retention</h6>
          <p className="small">PSC retains Personal Information for as long as necessary to fulfill the purposes for which it was collected, in accordance with applicable laws.</p>

          <h6 className="fw-bold text-dark mt-3">8. Data Subject Rights</h6>
          <ul className="small" style={{ listStyleType: "bullet" }}>
            <li>Right to request access to and copies of their data (Subject Access).</li>
            <li>Right to withdraw consent (if applicable).</li>
            <li>Right to data portability (under certain circumstances).</li>
            <li>Right to erasure in specific situations.</li>
          </ul>

          <h6 className="fw-bold text-dark mt-3">9. International Data Transfers</h6>
          <p className="small">The PSC may transfer Personal Information across borders when necessary. These transfers will be carried out in accordance with applicable data protection regulations.</p>

          <h6 className="fw-bold text-dark mt-3">10. Compliance with Specific Regulations</h6>
          <p className="small">The PSC commits to compliance with all applicable data protection regulations in Nigeria, including but not limited to GDPR and the Nigeria Data Protection Act.</p>

          <h6 className="fw-bold text-dark mt-3">11. Changes to this Policy</h6>
          <p className="small">The PSC may update this policy from time to time. Updates will be effective upon posting the revised policy on our Recruitment Portal.</p>
        </div>

        {/* Footer / Contact */}
        <div className="bg-light p-3 rounded mt-4 border">
          <p className="small mb-2">
            <strong>LOCATION:</strong> If you have any queries at all in relation to your data and how we protect your data rights, please contact us:
          </p>
          <ul className="list-unstyled small mb-0 ps-2">
            <li><strong>Address:</strong> Police Service Commission, Jabi, Abuja.</li>
            <li><strong>Email:</strong> <a href="mailto:dpr@psc.gov.ng">dpr@psc.gov.ng</a></li>
            <li><strong>Phone:</strong> 07054992071 </li>
          </ul>
        </div>
        <p className="text-muted text-center mt-4 small" style={{ fontSize: '0.8rem' }}>
          This Privacy Policy was last updated on December 10, 2025.
        </p>
</div>
      </section>
      <Footer/>
      </div>
  )
}
